module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.audioSrc,
      "autoplay": "",
      "loop": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-38c751f6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/BackgroundAudio.vue
// module id = 202
// module chunks = 1